<div class="wiper-intro-page">
	<section class="hero">
		<img [src]="heroImage" alt="Bosch SMARTFIT Pro" class="hero__image">
		<div class="hero__overlay"></div>
		<div class="page-shell hero__content">
			<div class="hero__eyebrow">{{ heroEyebrow }}</div>
			<h1 class="hero__title">{{ heroTitle }}</h1>
			<p class="hero__subtitle">{{ heroSubtitle }}</p>
		</div>
	</section>

	<section class="section section--videos">
		<div class="page-shell">
			<div class="section-header section-header--with-subtitle">
				<div class="section-header__title-row">
					<img [src]="installSectionIcon" alt="安装视频" class="section-header__icon">
					<h2 class="section-header__title">{{ videoSectionTitle }}</h2>
				</div>
				<p class="section-header__caption">{{ videoSectionCaption }}</p>
			</div>

			<div class="video-grid">
				<div class="video-card" *ngFor="let video of installationVideos; let i = index" (click)="openVideoModal(video)">
					<div class="video-card__player">
					<video class="video-card__video" [src]="video.videoUrl" preload="metadata" muted playsinline webkit-playsinline></video>
						<div class="video-card__overlay">
							<div class="video-card__play-btn">&#9654;</div>
						</div>
					</div>
					<div class="video-card__footer">
						<span class="video-card__label">{{ video.label }}</span>
					</div>
				</div>
			</div>
		</div>
	</section>

	<!-- 视频播放弹框 -->
	<div class="video-modal" *ngIf="showVideoModal" (click)="closeVideoModal()">
		<div class="video-modal__dialog" (click)="$event.stopPropagation()">
			<div class="video-modal__header">
				<span class="video-modal__title">{{ activeVideoLabel }}</span>
				<button class="video-modal__close" (click)="closeVideoModal()">&#x2715;</button>
			</div>
			<div class="video-modal__body">
				<div class="video-modal__loading" *ngIf="isVideoLoading">
					<nz-spin [nzSize]="'large'"></nz-spin>
					<p class="video-modal__loading-text">加载中...</p>
				</div>
				<video
					*ngIf="activeVideoUrl && !hasVideoError"
					class="video-modal__video"
					[src]="activeVideoUrl"
					controls
					autoplay
					muted
					playsinline
					webkit-playsinline
					(loadeddata)="onVideoLoaded()"
					(error)="onVideoError()">
					您的浏览器不支持视频播放。
				</video>
				<div class="video-modal__error" *ngIf="hasVideoError">
					<p>视频加载失败，请稍后重试</p>
				</div>
			</div>
		</div>
	</div>

	<section class="section section--product">
		<div class="page-shell">
			<div class="product-card">
				<h2 class="product-card__title">{{ productCardTitle }}</h2>

				<div class="product-card__body">
					<div class="product-card__image-shell">
						<div class="product-card__image-stage">
							<img [src]="productPackageImage" alt="博世容翼Pro包装" class="product-card__package-image">
							<img [src]="productBladeImage" alt="博世容翼Pro雨刮片" class="product-card__blade-image">
						</div>
					</div>

					<ul class="product-feature-list">
						<li class="product-feature-list__item" *ngFor="let feature of productFeatures">
							<span class="product-feature-list__dot"></span>
							<div class="product-feature-list__content">
								<h3 class="product-feature-list__title">{{ feature.title }}</h3>
								<p class="product-feature-list__desc">{{ feature.description }}</p>
							</div>
						</li>
					</ul>
				</div>
			</div>
		</div>
	</section>

	<section class="care-guide">
		<div class="page-shell">
			<div class="section-header">
				<h2 class="section-header__title section-header__title--lg">{{ careSectionTitle }}</h2>
				<p class="section-header__subtitle">{{ careSectionSubtitle }}</p>
			</div>

			<div class="care-guide__list">
				<article class="care-card" *ngFor="let card of careGuideCards">
					<div class="care-card__header">
						<div class="care-card__icon-wrap">
							<img [src]="card.iconBackground" alt="" class="care-card__icon-bg">
							<img [src]="card.icon" [alt]="card.title" class="care-card__icon">
						</div>
						<h3 class="care-card__title">{{ card.title }}</h3>
					</div>

					<ul class="care-card__list">
						<li class="care-card__item" *ngFor="let item of card.items">
							<span class="care-card__bullet">•</span>
							<span class="care-card__text">{{ item }}</span>
						</li>
					</ul>
				</article>
			</div>
		</div>
	</section>

	<section class="section section--heritage">
		<div class="page-shell heritage">
		<div class="heritage__eyebrow">{{ heritageEyebrow }}</div>
			<h2 class="heritage__title">{{ heritageTitle }}</h2>
			<div class="heritage__copy">
				<p *ngFor="let p of heritageParagraphs">{{ p }}</p>
			</div>
			<img [src]="heritageImage" alt="博世雨刮历史" class="heritage__image">
		</div>
	</section>
</div>
